/* NeonForge product.js - gallery, bundles, variants, AJAX add to cart, sticky ATC */
(function () {
  'use strict';

  var T = window.theme || {};

  function initProduct(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';

    var productJson = root.querySelector('[data-product-json]');
    var product = null;
    try {
      product = productJson ? JSON.parse(productJson.textContent) : null;
    } catch (e) {
      product = null;
    }
    var form = root.querySelector('[data-product-form], .product-form');
    var idInput = root.querySelector('[data-variant-id-input]');
    var qtyHidden = root.querySelector('[data-quantity-input]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    var addLabel = addBtn ? addBtn.querySelector('[data-add-label]') : null;
    var errorEl = root.querySelector('[data-form-error]');
    var bundleInputs = root.querySelectorAll('[data-bundle-input]');
    var summary = root.querySelector('[data-bundle-summary]');
    var qtyWrap = root.querySelector('[data-quantity-wrap]');
    var qtyInput = root.querySelector('[data-qty-input]');
    var priceWrap = root.querySelector('[data-product-price]');

    var state = { variantId: idInput ? idInput.value : null, quantity: 1, bundleQty: 1, label: '', price: '', available: addBtn ? !addBtn.disabled : true };

    /* ----- Gallery ----- */
    var gallery = root.querySelector('[data-gallery]');
    if (gallery) {
      var track = gallery.querySelector('[data-gallery-track]');
      var slides = Array.prototype.slice.call(track.children);
      var thumbs = gallery.querySelectorAll('[data-thumb]');

      var goToSlide = function (i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      };
      var currentIndex = function () { return Math.round(track.scrollLeft / (track.clientWidth || 1)); };

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { goToSlide(parseInt(t.dataset.thumb, 10)); });
      });
      var prev = gallery.querySelector('[data-gallery-prev]');
      var next = gallery.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', function () { goToSlide(currentIndex() - 1); });
      if (next) next.addEventListener('click', function () { goToSlide(currentIndex() + 1); });

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(function () {
          var idx = currentIndex();
          thumbs.forEach(function (t, i) {
            var on = i === idx;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-current', on ? 'true' : 'false');
          });
        });
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goToSlide(currentIndex() + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goToSlide(currentIndex() - 1); }
      });

      var dlg = root.querySelector('[data-lightbox]');
      if (dlg) {
        var img = dlg.querySelector('[data-lightbox-img]');
        gallery.addEventListener('click', function (e) {
          var z = e.target.closest('[data-lightbox-open]');
          if (!z) return;
          img.src = z.dataset.lightboxOpen;
          if (dlg.showModal) dlg.showModal();
        });
        dlg.querySelector('[data-lightbox-close]').addEventListener('click', function () { dlg.close(); });
        dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      }

      root._goToMedia = function (mediaId) {
        var idx = slides.findIndex(function (s) { return String(s.dataset.mediaId) === String(mediaId); });
        if (idx > -1) goToSlide(idx);
      };
    }

    /* ----- State -> UI ----- */
    function broadcast() {
      document.dispatchEvent(new CustomEvent('product:change', { detail: { state: state, section: root } }));
    }

    function setAvailable(available) {
      state.available = available;
      if (!addBtn) return;
      addBtn.disabled = !available;
      if (idInput) idInput.disabled = !available;
      if (addLabel) addLabel.textContent = available ? addBtn.dataset.label : T.strings.sold_out;
    }

    function syncHidden() {
      if (idInput && state.variantId) idInput.value = state.variantId;
      if (qtyHidden) qtyHidden.value = state.bundleQty * state.quantity;
    }

    /* ----- Bundles ----- */
    function applyBundle(input) {
      state.variantId = input.dataset.variantId;
      state.bundleQty = parseInt(input.dataset.quantity, 10) || 1;
      state.label = input.dataset.title;
      state.price = input.dataset.price;
      if (summary) {
        var parts = [input.dataset.title, input.dataset.price];
        if (input.dataset.save) parts.push('(' + input.dataset.save + ')');
        summary.textContent = parts.join(' - ');
      }
      setAvailable(input.dataset.available !== 'false');
      syncHidden();
      broadcast();
    }

    bundleInputs.forEach(function (input) {
      input.addEventListener('change', function () { if (input.checked) applyBundle(input); });
    });
    var checked = root.querySelector('[data-bundle-input]:checked') || bundleInputs[0];
    if (checked) { checked.checked = true; applyBundle(checked); }

    /* ----- Variant picker (when no bundles drive the variant) ----- */
    var picker = root.querySelector('[data-variant-picker]');
    if (picker && product) {
      picker.addEventListener('change', function () {
        var selected = [];
        picker.querySelectorAll('input:checked').forEach(function (r) { selected[parseInt(r.dataset.optionIndex, 10)] = r.value; });
        var match = product.variants.find(function (v) {
          return selected.every(function (val, i) { return v.options[i] === val; });
        });
        if (match) {
          state.variantId = String(match.id);
          state.label = match.title;
          state.price = null;
          syncHidden();
          setAvailable(match.available);
          if (priceWrap) {
            var money = function (cents) { return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }); };
            priceWrap.innerHTML = '<div class="price"><span class="price__current">' + money(match.price) + '</span>' + (match.compare_at_price > match.price ? ' <s class="price__compare">' + money(match.compare_at_price) + '</s>' : '') + '</div>';
            state.price = money(match.price);
          }
          if (match.featured_media && root._goToMedia) root._goToMedia(match.featured_media.id);
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
          broadcast();
        } else {
          setAvailable(false);
        }
      });
    }

    /* ----- Quantity ----- */
    if (qtyWrap && qtyInput) {
      var setQty = function (n) {
        state.quantity = Math.max(1, n || 1);
        qtyInput.value = state.quantity;
        syncHidden();
      };
      qtyWrap.querySelector('[data-qty-minus]').addEventListener('click', function () { setQty(state.quantity - 1); });
      qtyWrap.querySelector('[data-qty-plus]').addEventListener('click', function () { setQty(state.quantity + 1); });
      qtyInput.addEventListener('change', function () { setQty(parseInt(qtyInput.value, 10)); });
    }

    /* ----- AJAX add to cart ----- */
    if (form && addBtn) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn.disabled || addBtn.classList.contains('is-loading')) return;
        errorEl.hidden = true;
        addBtn.classList.add('is-loading');
        addBtn.setAttribute('aria-busy', 'true');
        if (addLabel) addLabel.textContent = T.strings.adding;

        var item = { id: parseInt(state.variantId, 10), quantity: state.bundleQty * state.quantity };
        window.NeonCart.add([item])
          .then(function () {
            if (T.cartType === 'drawer') window.NeonCart.open();
            else window.location.href = T.routes.cart;
          })
          .catch(function (err) {
            errorEl.textContent = err.message || T.strings.error;
            errorEl.hidden = false;
          })
          .then(function () {
            addBtn.classList.remove('is-loading');
            addBtn.removeAttribute('aria-busy');
            if (addLabel) addLabel.textContent = state.available ? addBtn.dataset.label : T.strings.sold_out;
          });
      });
    }

    /* ----- Sticky add to cart ----- */
    var sticky = document.querySelector('[data-sticky-atc]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      var stickyBtn = sticky.querySelector('[data-sticky-button]');
      var stickyVariant = sticky.querySelector('[data-sticky-variant]');
      var stickyPrice = sticky.querySelector('[data-sticky-price]');

      var io = new IntersectionObserver(function (entries) {
        var past = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
        sticky.setAttribute('aria-hidden', String(!past));
        stickyBtn.tabIndex = past ? 0 : -1;
      });
      io.observe(addBtn);

      stickyBtn.addEventListener('click', function () { addBtn.click(); });

      document.addEventListener('product:change', function (e) {
        var s = e.detail.state;
        if (stickyVariant) stickyVariant.textContent = s.label || '';
        if (stickyPrice && s.price) stickyPrice.textContent = s.price;
        stickyBtn.disabled = !s.available;
      });
      broadcast();
    }
  }

  function init() {
    document.querySelectorAll('[data-product-section]').forEach(initProduct);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
